import { ID } from "common/entities/IEntity";


export interface ICourseParams {
	id?: ID;
	ids?: ID[];
	itemId?: ID;
	itemIds?: ID[];
	itemExternalId?: string;
	itemExternalIds?: string[];
	query?: string;
	pageSize?: number;
	pageNumber?: number;
	sort?: string;
	filter?: "SUBSCRIBED" | "RECOMMENDED" | "FEATURED" | "BOOKMARKED";
	tagIds?: ID[];
	tagOrCondition?: boolean;
	displayRangeStart?: Date;
	displayRangeEnd?: Date;
	catalogIds?: ID[];
	language?: string;
	itemTypeIds?: ID[];
	notIncludeItemTypeIds?: ID[];
	bundleTagIds?: ID[];
	sortByModifyDays?: number;
	institution?:string;
}

export const courseParamNames = [
	'id',
	'ids',
	'itemId',
	'itemIds',
	'itemExternalIds',
	'query',
	'filter',
	'tagIds',
	'tagOrCondition',
	'requiredTagIds',
	'displayRangeStart',
	'displayRangeEnd',
	'catalogIds',
	'language',
	'pageSize',
	'sort',
	'pageNumber',
	'itemTypeIds',
	'notIncludeItemTypeIds',
	'bundleTagIds',
	'sortByModifyDays',
	'institution',
	'isLoadMore'
];



// WEBPACK FOOTER //
// ./src/panels/catalog/entities/CourseParams.ts